/* eslint-disable @typescript-eslint/no-this-alias */
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SeoBaseService, SeoGtmService } from '@tn-goldenfront/core/seo';
import createCanonicalURL from './core/utils/seo-helper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public loading = true;
  equisLoadingSize: any = 'large';
  constructor(
    private seoBaseService: SeoBaseService,
    private seoGtmService: SeoGtmService,
  ) {
    this.seoBaseService.init();
    this.seoBaseService.createCanonicalURL = createCanonicalURL.bind(
      this.seoBaseService,
    );
    this.seoGtmService.loadGTMById(environment.seo.gtmId);
    this.loading = false;
  }
}
